module.exports = __webpack_public_path__ + "static/media/map-point.98930f0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-point.png
// module id = 340
// module chunks = 0